import html2canvas from "html2canvas";

export const createScreenshot = (isArtus) => {
  const screenshotArea = document.querySelector("#screenshot-area");
  const rightSide = document.querySelector("#add-button-container");
  const heading = document.querySelector("#front-view-heading");
  if (heading) {
    heading.style.display = "none";
  }

  const getScale = (maxWidth, maxHeight = screenshotArea.scrollHeight) =>
    5 * Math.min(
      maxWidth / (screenshotArea.scrollWidth - rightSide.offsetWidth),
      maxHeight / screenshotArea.scrollHeight
    );

  // html2canvas options
  const options = {
    onclone: (copy) => {
      const buttons = copy.querySelectorAll(".MuiButtonBase-root");
      buttons.forEach((button) => (button.style.display = "none"));
      if (heading) {
        heading.style.display = "block";
      }
      if (isArtus) {
        // set stack order of each box
        const boxes = copy.querySelectorAll("#box-image");
        boxes.forEach((box) => (box.style.zIndex = -1));
      }
    },
    allowTaint: true,
    // uncomment in dev mode if needed, e.g. for safari
    // useCORS: true,
    scale: getScale(1000),
    // set size of canvas to consider overflow
    width: screenshotArea.scrollWidth - rightSide.offsetWidth,
    height: screenshotArea.scrollHeight,
  };
  let screenshot = "";

  return html2canvas(screenshotArea, options).then((canvas) => {
    screenshot = canvas.toDataURL("image/png");
    return screenshot;
  });
};
